import { IUserAuth } from 'common/user/auth/userAuth.service';
import { A9Service } from 'components/system';
import { ISystemInfo } from 'common/index/services/system-info';
import { GolftvCwiLanguageEnum } from 'common/golftv/services/types/enum';

export const CwiNavigationServiceName = 'cwiNavigationService';

@A9Service(CwiNavigationServiceName)
export class CwiNavigationService {
    private cwiUrlPrefix: string;
    private host: string;
    private protocol: string;
    private urlPrefix: string;
    private userAuth: IUserAuth;

    constructor(
        protected $location: angular.ILocationService,
        protected $injector: angular.auto.IInjectorService,
        private systemInfo: ISystemInfo
    ) {
        this.userAuth = this.$injector.get<IUserAuth>('userAuth');
        this.cwiUrlPrefix = 'a9online';
        this.protocol = this.$location.protocol();
        this.host = this.$location.host();
        const cwiUrl = window.configuration.cwi?.url;

        this.urlPrefix = cwiUrl ?? `${this.protocol}://${this.host}/${this.cwiUrlPrefix}`;
    }

    /**
     * Builds a CWI URL with the common base path and required query parameters.
     * Centralizes tenant and language handling to avoid duplication across link generators.
     */
    private buildUrl(path: string): string {
        const tenantId = this.userAuth.tenantId;
        const language = this.getLanguage();
        return `${this.urlPrefix}/#${path}?tenant=${tenantId}&language=${language}`;
    }

    /**
     * Returns the language to be used for the CWI URL based on the system information
     */
    private getLanguage(): string {
        return this.systemInfo.isFfg() ? GolftvCwiLanguageEnum.fr : GolftvCwiLanguageEnum.de;
    }

    public getLiveScoreUrl(tournamentId: number, prizeId: number): string {
        return this.buildUrl(`/tournaments/${tournamentId}/live-scoring/${prizeId}`);
    }

    public getTournamentResultsUrl(tournamentId: number, prizeId: number): string {
        return this.buildUrl(`/tournaments/${tournamentId}/result/${prizeId}`);
    }

    public getTournamentDrawUrl(tournamentId: number): string {
        return this.buildUrl(`/tournaments/${tournamentId}/draw`);
    }

    public getTournamentSignUpUrl(tournamentId: number, isTeam: boolean): string {
        const signUpPath = isTeam ? 'team-sign-up' : 'single-sign-up';
        return this.buildUrl(`/tournaments/${tournamentId}/${signUpPath}`);
    }
}
